import { Inject, LOCALE_ID, Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';

const dateWithTimezoneRegex: RegExp = /^(.*\d{2}:\d{2}:\d{2})(\.\d+)?([+-]\d{2}:\d{2}|Z)$/;

@Pipe({
    name: 'pimDate',
    standalone: false
})
export class PimDatePipe implements PipeTransform {
	private datePipe: DatePipe;
	private dateFormat: string = 'dd.MM.yyyy | HH:mm';

	constructor(@Inject(LOCALE_ID) locale: string) {
		this.datePipe = new DatePipe(locale);
	}

	transform(value: string | undefined, normalizeTimeZone?: boolean): unknown {
		if (!value) {
			return '';
		}

		// With timezone
		if (dateWithTimezoneRegex.test(value)) {
			return this.datePipe.transform(value, this.dateFormat);
		}

		// Fallback
		return this.datePipe.transform(value, this.dateFormat, normalizeTimeZone ? '+0000' : undefined);
	}
}
